import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { HttpClientService } from './http/http-client.service';

@Injectable()
export class EnvironmentService {
    public constructor(private httpService: HttpClientService) {
        this._environment = environment;
    }

    private _environment: any;

    public get environment(): any {
        return this._environment;
    }

    public getEnvironmentFile(): Observable<any> {
        return this.httpService.get('/assets/environment.json')
                   .pipe(
                       tap((env) => {
                           this._environment = Object.assign(this._environment, env);
                       }),
                   );
    }

    public getEnvironmentAlias(): string {
        const envName = environment.envName;
        switch (envName) {
            case 'dev':
                return 'dev'; // 'eagle';
            case 'qa':
                return 'qa'; // 'raven';
            case 'uat':
                return 'uat'; // 'vulture';
            case 'staging':
                return 'falcon';
            default:
                return null;
        }
    }
}
